import { TYPE } from "@gaoya/shared";
import { privacyLayout } from "../../ui/hall.js";
import { C, drawPanel, drawSeal, wrapText } from "../theme.js";
import { drawScrim } from "./settings.js";
import type { UiState } from "../../game/state.js";

export function drawPrivacy(ctx: CanvasRenderingContext2D, _ui: UiState, w: number, h: number): void {
  drawScrim(ctx, w, h, 0.6);
  const g = privacyLayout(w, h);
  drawPanel(ctx, g.x, g.y, g.w, g.h, 20, C.card, null, null);
  drawSeal(ctx, g.x + 24 + 16, g.y + 36, 32, "护", C.seal);
  ctx.fillStyle = C.ink;
  ctx.font = `700 19px ${TYPE.serif}`;
  ctx.textAlign = "left";
  ctx.textBaseline = "middle";
  ctx.fillText("用户隐私保护提示", g.x + 68, g.y + 36);
  ctx.fillStyle = C.ink2;
  ctx.font = `13px ${TYPE.sans}`;
  ctx.textBaseline = "top";
  const used = wrapText(ctx, "收集处理个人信息前，请先阅读并同意隐私政策。", g.x + 24, g.y + 70, g.w - 48, 20);
  ctx.fillStyle = C.ink;
  ctx.font = `14px ${TYPE.sans}`;
  wrapText(
    ctx,
    "我们将收集你的微信昵称、头像，用于展示同玩好友胜场排行榜，方便查看好友对战成绩。拒绝后不会收集上述信息，但无法使用微信身份入座。",
    g.x + 24,
    g.y + 70 + used + 12,
    g.w - 48,
    23,
  );
  ctx.fillStyle = C.seal;
  ctx.font = `600 14px ${TYPE.sans}`;
  ctx.textAlign = "center";
  ctx.textBaseline = "middle";
  ctx.fillText("阅读《用户隐私保护指引》 ›", g.read.x + g.read.w / 2, g.read.y + g.read.h / 2);
}
